import type { AnySelfOwnedWidgetClass } from './selfOwnedWidget';
import type { SelfOwnedWidgetType } from './selfOwnedWidgetTypes';
import type { WidgetType } from '@thinkalpha/ui-types/contracts/workspace';
import type { AnySelfOwnedWidgetDefinition } from 'src/lib/widget/WidgetDefinition';
import {
    platformsWidgetDefinition,
    symbolsWidgetDefinition,
    tradersWidgetDefinition,
} from 'src/lib/widget/widgets/aggregated-risk';
import { alphaEyeWidgetDefinition } from 'src/lib/widget/widgets/alpha-eye';
import { eventsWidgetDefinition } from 'src/lib/widget/widgets/events';
import { filingsWidgetDefinition } from 'src/lib/widget/widgets/filings';
import { newsWidgetDefinition } from 'src/lib/widget/widgets/news';
import { notepadWidgetDefinition } from 'src/lib/widget/widgets/notepad';
import { resultsWidgetDefinition } from 'src/lib/widget/widgets/results';
import { tableWidgetDefinition } from 'src/lib/widget/widgets/table';
import { tradingViewChartWidgetDefinition } from 'src/lib/widget/widgets/tradingview-chart';
import type { LegacyWidgetViewModel, SelfOwnedWidgetViewModel, WidgetViewModel } from 'src/store/types';

const selfOwnedWidgetDefinitions = {
    filings: filingsWidgetDefinition,
    events: eventsWidgetDefinition,
    news: newsWidgetDefinition,
    'alpha-eye': alphaEyeWidgetDefinition,
    notepad: notepadWidgetDefinition,
    platforms: platformsWidgetDefinition,
    results: resultsWidgetDefinition,
    symbols: symbolsWidgetDefinition,
    table: tableWidgetDefinition,
    traders: tradersWidgetDefinition,
    'tradingview-chart': tradingViewChartWidgetDefinition,
} satisfies Record<SelfOwnedWidgetType, AnySelfOwnedWidgetDefinition>;

export const selfOwnedWidgetRegistry: ReadonlyMap<WidgetType, AnySelfOwnedWidgetClass> = new Map<
    WidgetType,
    AnySelfOwnedWidgetClass
>(Object.values(selfOwnedWidgetDefinitions).map((definition) => [definition.type, definition.widgetClass]));

export function isSelfOwnedWidget(widget: WidgetViewModel): widget is SelfOwnedWidgetViewModel {
    return selfOwnedWidgetRegistry.has(widget.type);
}

export function isLegacyWidget(widget: WidgetViewModel): widget is LegacyWidgetViewModel {
    return !selfOwnedWidgetRegistry.has(widget.type);
}
